module.exports = __webpack_public_path__ + "static/media/chipsHandle1.e7497358.mp3";